/**
 * Mask a phone for OTP copy: `XXX-XXX-5437` (last 4 digits visible).
 */
export function maskPhoneForOtp(mobile?: string | null): string {
  const digits = String(mobile ?? '').replace(/\D/g, '')
  if (digits.length < 4) return 'XXX-XXX-XXXX'
  return `XXX-XXX-${digits.slice(-4)}`
}
